var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"iframe-full",attrs:{"src":"https://manage.zesthub.com/document/deployment/production/sfa/view"}})])
}]

export { render, staticRenderFns }